import React, { useEffect } from 'react';
import { func, oneOf } from 'prop-types';
import errorIcon from '../../../../assets/images/shared/download-failed-new@3x.png';
import * as styles from './styles/styles.module.scss';
import Modal from '../Modal';
import LoadingSpinner from '../LoadingSpinner';
import successUpload from '../../../../assets/images/icons/share/filled@2x.png';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const getVariant = variant => {
  switch (variant) {
    case 'saving':
      return {
        element: <LoadingSpinner />,
        text: `${StringConstantsMixin.strings.MAP_CREATOR.SAVING_YOUR_MAP}...`
      };
    case 'error-saving':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.MAP_CREATOR.ERROR_SAVING} />,
        text: StringConstantsMixin.strings.MAP_CREATOR.ERROR_SAVING
      };
    case 'error':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.MAP_CREATOR.ERROR_SAVING} />,
        text: StringConstantsMixin.strings.ERROR_OCCURRED
      };
    case 'error-cannot-route':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.TRACK_DETAIL.CANNOT_ROUTE} />,
        text: StringConstantsMixin.strings.TRACK_DETAIL.CANNOT_ROUTE
      };
    case 'error-routing':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.TRACK_DETAIL.ERROR_ROUTING} />,
        text: StringConstantsMixin.strings.TRACK_DETAIL.ERROR_ROUTING
      };
    case 'error-deleting-map':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.TRACK_DETAIL.ERROR_DELETING} />,
        text: StringConstantsMixin.strings.TRACK_DETAIL.ERROR_DELETING
      };
    case 'loading': {
      return {
        element: <LoadingSpinner />,
        text: StringConstantsMixin.strings.SEARCH.LOADING
      };
    }
    case 'saved':
      return {
        element: <img src={successUpload} className={styles.iconImage} alt={StringConstantsMixin.strings.MAP_CREATOR.MAP_SAVED} />,
        text: `${StringConstantsMixin.strings.MAP_CREATOR.MAP_SAVED}!`
      };
    default:
      return {};
  }
};

const ProgressDialog = ({ updateProgressDialog, variant }) => {
  const closeModal = () => {
    updateProgressDialog(null);
  };

  useEffect(() => {
    // automatically closes the modal if saved or error
    if (['saved', 'error', 'error-deleting-map'].includes(variant)) {
      setTimeout(() => {
        closeModal();
      }, 2000);
    }
  }, [variant]);

  const { element, text } = getVariant(variant);

  return (
    <Modal handleBackgroundClick={closeModal}>
      <div className={styles.container}>
        {element}
        <div className={styles.text}>{text}</div>
      </div>
    </Modal>
  );
};

ProgressDialog.propTypes = {
  variant: oneOf(['saving', 'error', 'error-cannot-route', 'error-routing', 'saved', 'error-deleting-map']).isRequired,
  updateProgressDialog: func.isRequired
};

export default ProgressDialog;
